import api from '../../services/api'
import { LOGIN, USER_DATA } from '../../constants/api'
import { LOCAL_STORAGE_AUTH_NAME } from '../../constants/utils'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const loginUser = createAsyncThunk(
  LOGIN, async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(LOGIN, data)
      localStorage.setItem(LOCAL_STORAGE_AUTH_NAME, JSON.stringify(response.data));
      return response.data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const getUserDetails = createAsyncThunk(
  USER_DATA, async () => {
    try {
      const response = await api.get(USER_DATA)
      return response.data
    } catch (error) {
      return error.message
    }
  }
)